import * as THREE from 'three';
import texturePath from '../../assets/img/textures/grid.jpg';

export default class Terrain
{
    constructor(scene, color)
    {
        this.scene = scene;
        this.color = color;
        this.size = new THREE.Vector2(800, 800);
        // this.setup();
    }

    setup()
    {
        let texLoader = new THREE.TextureLoader();
        let groundMap = texLoader.load(texturePath, (tex) =>
        {
            tex.wrapS = THREE.RepeatWrapping;
            tex.wrapT = THREE.RepeatWrapping;
            let repeatCount = 100;
            tex.repeat.set(repeatCount, repeatCount);
            tex.offset.set(0.5, 0.5);
            tex.anisotropy = 16; 
            //tex.minFilter = THREE.LinearMipmapNearestFilter;
        }); 
        
        let groundPlane = new THREE.Mesh(new THREE.PlaneBufferGeometry(this.size.x, this.size.y), new THREE.MeshStandardMaterial({
            color: this.color,
            map: groundMap,
            bumpMap: groundMap,
            bumpScale: 0.005,
            metalness: 0.01,
            roughness: 0
        }));

        groundPlane.receiveShadow = true;
        groundPlane.position.y = 0;
        groundPlane.quaternion.setFromAxisAngle(new THREE.Vector3(1, 0, 0), -Math.PI / 2);
        this.scene.add(groundPlane);
    };

    getSize()
    {
        return this.size.x;
    };
}